import React, { useEffect } from 'react';
import { useStaticQuery, graphql } from "gatsby";
import { Col, Row, Container } from 'react-bootstrap';
import $ from "jquery";
import { Link } from 'gatsby';
import ReactMarkdown from "react-markdown"
import rehypeRaw from 'rehype-raw'
import { useLocation } from "@reach/router"
import ImgBox from '@components/img-box/img-box';
import { Logo } from '@components/icon/icon';
import './styles/_index.scss';
import { TwitterNews, FacebookNews, InstagramNews, LinkedinNews, ArrowDown } from '@components/icon/icon'
import gql from "graphql-tag"
import { useQuery } from '@apollo/client';



function NewsContent(props) {
    const location = useLocation(); 
    let AOS;
    useEffect(() => {
        const AOS = require("aos");
        AOS.init({
            once: true,
            disable: 'mobile'
        });
    }, [])

    useEffect(() => {
        if (AOS) {
            AOS.refresh();
        }

        var win = $(window);
        win.scroll(function () {
            var sticky = $('.sticky-header'),
                scroll = win.scrollTop();

            if (scroll >= 40) sticky.addClass('fixed');
            else sticky.removeClass('fixed');
        });
    });

    return (
        <>

            <div className="news-content text-20">

                {props.Banner_Image && props.Banner_Image?.publicURL &&
                    <div className="news-main-banner">
                        <img src={props.Banner_Image.publicURL} alt={props.Title} />

                    </div>
                }
                <div className="news-content-text">
                    <ReactMarkdown rehypePlugins={[rehypeRaw]} children={props.Content} />
                </div>
                <div className='separator'></div>
                <h3>Share this Post</h3>
                <div className="socials">
                    <ul>
                        <li>
                            <a href={`https://www.facebook.com/sharer?u=${location.href}`} target="_blank">

                                <span>Facebook</span> <FacebookNews /></a></li>
                        <li>
                            <a href={`https://twitter.com/intent/tweet?url=${location.href}`} target="_blank">

                                <span>Twitter</span> <TwitterNews /></a></li>
                        <li><a href="#" target="_blank"><span>Instagram</span> <InstagramNews /></a></li>
                        <li><a href={`https://www.linkedin.com/cws/share?url=${location.href}`} target="_blank"><span>Linkedin</span> <LinkedinNews /></a></li>
                    </ul>
                </div>
            </div>

        </>
    );
}

export default NewsContent
